import { useState, useEffect, useRef } from 'react';
// import ReactMarkdown from 'react-markdown';
import Markdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import remarkGfm from 'remark-gfm'
// import rehypeSanitize, { defaultSchema } from 'rehype-sanitize';
import { getUserProfile, getAccessToken } from '../utils/auth';

// // Define a schema that allows data URLs for images
// const schema = {
//   ...defaultSchema,
//   protocols: {
//     ...defaultSchema.protocols,
//     src: ['http', 'https', 'data']
//   }
// };


function Assistant() {
  const [thread, setThread] = useState(() => {
    const saved = localStorage.getItem('chatThread');
    return saved ? JSON.parse(saved) : [];
  });
  const [inputValue, setInputValue] = useState('');
  const messagesEndRef = useRef(null);

  useEffect(() => {
    const fetchMessages = async () => {
      const messagesFetched = localStorage.getItem('messagesFetched');
      if (messagesFetched) return;
      
      try {
        const token = await getAccessToken();
        if (token) {
          const response = await fetch(`${process.env.REACT_APP_ORCHESTRATOR_ENDPOINT}/assistant/initiate_thread`, {
            method: 'GET',
            headers: {
              'Authorization': `Bearer ${token}`,
              'Content-Type': 'application/json'
            }
          });
          if (response.ok) {
            const new_thead = await response.json();
            const messages = new_thead.messages || [];
            const userProfile = getUserProfile();
            const processedMessages = messages.map(message => {
              if (message.content.includes('<user_name>') && userProfile) {
                const userName = `${userProfile.first_name} ${userProfile.last_name}`;
                message.content = message.content.replace(/<user_name>/g, userName);
              }
              return message;
            });
            setThread(prevThread => [...prevThread, ...processedMessages]);
            localStorage.setItem('messagesFetched', 'true');
          }
        }
      } catch (error) {
        console.error('Failed to fetch messages:', error);
      }
    };
    
    fetchMessages();
  }, []);

  useEffect(() => {
    localStorage.setItem('chatThread', JSON.stringify(thread));
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [thread]);

  const handleInputChange = (e) => {
    setInputValue(e.target.value);
    e.target.style.height = 'auto';
    e.target.style.height = e.target.scrollHeight + 'px';
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && e.metaKey) {
      e.preventDefault();
      handleSendMessage(e);
    }
  };

  const handleSendMessage = async (e) => {
    e.preventDefault();
    if (inputValue.trim()) {
      const profile = getUserProfile();
      const userMessage = {
        content: inputValue,
        timestamp: Date.now(),
        userId: profile?.id || 'anonymous'
      };
      setThread(prevThread => [...prevThread, userMessage]);
      
      try {
        const token = await getAccessToken();
        if (token) {
          const response = await fetch(`${process.env.REACT_APP_ORCHESTRATOR_ENDPOINT}/assistant/ask_question`, {
            method: 'POST',
            headers: {
              'Authorization': `Bearer ${token}`,
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({ question: inputValue })
          });
          
          if (response.ok) {
            const data = await response.json();
            console.log('Assistant response:', data)
            const assistantMessage = {
              content: data.response || 'Sorry, I could not process your request: ' + data.error,
              timestamp: Date.now(),
              userId: 'lucent@applucent.com'
            };
            setThread(prevThread => [...prevThread, assistantMessage]);
          }
        }
      } catch (error) {
        console.error('Failed to get assistant response:', error);
      }
      
      setInputValue('');
      const textarea = e.target.closest('form').querySelector('textarea');
      textarea.style.height = 'auto';
    }
  };
  

  return (
    <div className="assistant-panel-content">
      <h2 className="assistant-panel-title">Ask Lucent...</h2>
      <div className="chat-container">
        <div className="chat-message-container">
          <div className="chat-messages">
            {thread.map((message, index) => (
              <div 
                key={index} 
                className="message" 
                // style={message.userId === "lucent@applucent.com" ? {backgroundColor: '#e3f2fd'} : {}}
                style={message.userId === "lucent@applucent.com" ? {backgroundColor: '#eeebffff'} : {}}
              >
                <div className="message-content">
                  {message.content.includes('data:image/') ? (
                    <div dangerouslySetInnerHTML={{ __html: message.content }} />
                  ) : (
                    <Markdown 
                      // rehypePlugins={[rehypeRaw]}
                      // rehypePlugins={[remarkGfm]}
                      // rehypePlugins={[remarkGfm, rehypeRaw, rehypeSanitize]}
                      // rehypePlugins={[remarkGfm, rehypeRaw, rehypeSanitize, { schema }]}
                      rehypePlugins={[remarkGfm, rehypeRaw]}
                      components={{
                        img: ({node, src, alt, ...props}) => {
                          console.log('Image src:', src); // Debug log
                          return <img src={src} alt={alt} {...props} style={{maxWidth: '100%', height: 'auto'}} />;
                        }
                      }}
                    >
                      {message.content}
                    </Markdown>
                  )}
                </div>
                <div className="message-meta" style={{fontSize: '0.8em', color: 'gray'}}>
                  <span 
                    title={new Date(message.timestamp).toLocaleString()}
                  >
                    {new Date(message.timestamp).toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'})}
                  </span>
                  {' - '}{(() => {
                    const profile = getUserProfile(message.userId);
                    return profile ? `${profile.first_name} ${profile.last_name}` : message.userId;
                  })()}
                </div>
              </div>
            ))}
            <div ref={messagesEndRef} />
          </div>
        </div>
        <div className="chat-input-container">
          <form className="chat-input" onSubmit={handleSendMessage}>
            <textarea
              value={inputValue}
              onChange={handleInputChange}
              onKeyDown={handleKeyDown}
              placeholder="Type a message..."
              rows={1}
              style={{ resize: 'none', overflow: 'hidden' }}
            />
          </form>
        </div>
      </div>
    </div>
  );
}

export default Assistant;